import { render, staticRenderFns } from "./MedecinDetailTuteuredit.vue?vue&type=template&id=746c1f2f&"
import script from "./MedecinDetailTuteuredit.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailTuteuredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports